"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.map");

require("core-js/modules/es.function.name");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.findEqual = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _formElements = require("@evidation/form-elements");

var _utils = require("../../utils");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _lodash = _interopRequireDefault(require("lodash"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils2 = require("../../components/utils");

var Container = _styledComponents["default"].div.withConfig({
  displayName: "selectAdvanced__Container",
  componentId: "sc-187zaic-0"
})(["margin-bottom:8px;.react-select__control{border-radius:0;border:", ";border-bottom:", ";}"], function (props) {
  return props.inputStyle === "sm_minimal" ? "0" : "1px solid #ccc";
}, function (props) {
  return props.inputStyle === "sm_minimal" ? "1px solid #E6E6E6" : "1px solid #ccc";
});

var SafeProps = ["addLabelText", 'aria-describedby', 'aria-label', 'aria-labelledby', "arrowRenderer", "autoBlur", "autofocus", "autosize", "backspaceRemoves", "backspaceToRemoveMessage", "className", "clearAllText", "clearRenderer", "clearValueText", "clearable", "deleteRemoves", "delimiter", "escapeClearsValue", "filterOption", "filterOptions", "ignoreAccents", "ignoreCase", "inputProps", "inputRenderer", "instanceId", "isLoading", "joinValues", "labelKey", "matchPos", "matchProp", "menuBuffer", "menuContainerStyle", "menuRenderer", "menuStyle", "isMulti", "name", "noResultsText", "onBlurResetsInput", "onChange", "onClose", "onCloseResetsInput", "onFocus", "onInputChange", "onInputKeyDown", "onMenuScrollToBottom", "onOpen", "onValueClick", "openAfterFocus", "openOnFocus", "optionClassName", "optionComponent", "optionRenderer", "options", "pageSize", "placeholder", "required", "resetValue", "scrollMenuIntoView", "searchable", "simpleValue", "style", "tabIndex", "tabSelectsValue", "valueComponent", "valueKey", "valueRenderer", "wrapperStyle"];

var findEqual = function findEqual(options) {
  return function (item) {
    return _lodash["default"].find(options, function (o) {
      return _lodash["default"].isString(o) ? _lodash["default"].isEqual(item, o) : _lodash["default"].isEqual(item, o.value);
    });
  };
};

exports.findEqual = findEqual;

var SelectAdvanced = function SelectAdvanced(props) {
  var error = props.error,
      required = props.required,
      label = props.label,
      labelStyle = props.labelStyle,
      inputStyle = props.inputStyle,
      name = props.name,
      valueFromProps = props.value,
      optionsFromProps = props.options,
      config = props.config,
      initialValue = props.initialValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  var options = (0, _utils.generateOptionsListFromArrayOrObjectArray)(optionsFromProps);
  var FindItemInOptions = findEqual(options); // covering the case where the output is an array
  // this can ocurr if it is a multi select

  var getValueFromOption = function getValueFromOption(opt) {
    return _lodash["default"].isArray(opt) ? _lodash["default"].map(opt, function (item) {
      return item.value;
    }) : opt.value;
  }; // covering the case where the output is an array
  // this can ocurr if it is a multi select


  var value = _lodash["default"].isArray(valueFromProps) ? _lodash["default"].map(valueFromProps, function (item) {
    return FindItemInOptions(item);
  }) : FindItemInOptions(valueFromProps);
  if (_lodash["default"].isUndefined(value) && !_lodash["default"].isUndefined(initialValue)) props.onChange(getValueFromOption(initialValue));
  return /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
    required: required,
    label: label,
    labelStyle: labelStyle,
    labelFor: name
  }, /*#__PURE__*/_react["default"].createElement(Container, {
    inputStyle: inputStyle,
    "data-test": "select-advanced"
  }, /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], (0, _extends2["default"])({}, _lodash["default"].pick(props, SafeProps), {
    classNamePrefix: "react-select",
    onChange: function onChange(opt) {
      var selectedValue = opt ? getValueFromOption(opt) : null;
      props.onChange(selectedValue);
    }
  }, config, {
    options: options,
    value: value,
    defaultValue: initialValue,
    isDisabled: disabled,
    isClearable: true
  }))), error.length !== 0 && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, error));
};

SelectAdvanced.propTypes = {
  name: _propTypes["default"].string,
  label: _propTypes["default"].string,
  labelStyle: _propTypes["default"].oneOf(["light", "dark", "darker", "gray", "black", "achievement"]),
  inputStyle: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  options: _propTypes["default"].array.isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  style: _propTypes["default"].object,
  error: _propTypes["default"].string,
  simpleValue: _propTypes["default"].bool,
  autoBlur: _propTypes["default"].bool,
  config: _propTypes["default"].object
};
SelectAdvanced.defaultProps = {
  name: "select_dropdown",
  onChange: function onChange() {
    return false;
  },
  onBlur: function onBlur() {
    return true;
  },
  inputStyle: "achievement",
  labelStyle: "dark",
  simpleValue: true,
  autoBlur: false,
  required: false,
  style: {},
  error: "",
  disabled: false,
  placeholder: "",
  className: "",
  isSearchable: true,
  config: {}
};

var FilterProps = function FilterProps(props) {
  return /*#__PURE__*/_react["default"].createElement(SelectAdvanced, (0, _utils2.util_commonInputParamters)(props));
};

var _default = FilterProps;
exports["default"] = _default;